export enum SystemParametersEnum {
  IVA_DEFECTO = 'IVA_DEFECTO',
  COSTO_ADMINISTRATIVO_HOME = 'COSTO_ADMINISTRATIVO_HOME',
  MANTENIMIENTO = 'MANTENIMIENTO',
  WIFI_6 = 'WIFI_6',
  ROUTER_AC = 'ROUTER_AC',
  MINI_UPS = 'MINI_UPS',
  ANDROID_TV = 'ANDROID_TV',
  EQUIPOS_ADICIONALES_PREVENTA = 'EQUIPOS_ADICIONALES_PREVENTA',
  VALOR_MINIMO_EQUIFAX = 'VALOR_MINIMO_EQUIFAX',
  USER_PERMISO_AYUDA_SOCIAL = 'USER_PERMISO_AYUDA_SOCIAL',

}
